export default "__VITE_ASSET__Dw16evkM__"